/// <reference path="../../../Common/Helpers/GridEditorBase.ts" />

namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor()
    export class QueueFieldListEditor extends Common.GridEditorBase<QueueField> {
        protected getColumnsKey() { return "Workflow.QueueField" };
        protected getDialogType() { return QueueFieldDialog; }

        constructor(container: JQuery) {
            super(container);

            this.slickGrid.setSelectionModel(new Slick.RowSelectionModel());
            Serenity.GridUtils.makeOrderable(this.slickGrid, (items: number[], location: number) => {
                if (!items || !items.length)
                    return;

                this.moveItem(items[0], location);
            });
        }

        private moveItem(from: number, to: number) {

            if (from == to)
                return;

            var items = this.view.getItems();
            if (to >= items.length)
                return;

            var item = items[from];
            items.splice(from, 1);
            items.splice(to - (from < to ? 1 : 0), 0, item);
            for (var i = 0; i < items.length; i++)
                items[i].DisplayOrder = i + 1;
            this.view.setItems(items, false);
        }

        protected getAddButtonCaption() {
            return "Add Field";
        }

        protected getButtons() {
            var buttons = super.getButtons();

            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].icon = 'fa-plus';

            return buttons;
        }

        validateEntity(row: QueueField, id) {
            row.Alignment = Q.trimToNull(row.Alignment);
            row.DateTimeKind = Q.toId(row.DateTimeKind);
            row.QuickSearchType = Q.toId(row.QuickSearchType);
            return true;
        }

        protected updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('add-button').toggle(!this.readOnly);
        }

        protected getColumns() {
            var columns = super.getColumns();
            var displayOrder = Q.indexOf(columns, x => x.field == "Display Order")
            Q.insert(columns, displayOrder < 1 ? 0 : displayOrder, {
                field: '__move',
                name: '',
                width: 30,
                minWidth: 30,
                maxWidth: 30,
                cssClass: 'align-center',
                behavior: 'selectAndMove',
                format: ctx => `<i class="fa fa-bars" style="color: limegreen !important; cursor: move; font-size: 14px;"></i>`
            });

            return columns;
        }
    }
}